/**
 * Logger utility that only shows logs in development mode
 * Uses Vite's import.meta.env.DEV to determine environment
 */

class Logger {
  /**
   * Log message - only shows in development mode
   */
  static log(message: string, ...args: any[]): void {
    if (import.meta.env.DEV) {
      console.log(message, ...args);
    }
  }

  /**
   * Warning message - only shows in development mode
   */
  static warn(message: string, ...args: any[]): void {
    if (import.meta.env.DEV) {
      console.warn(message, ...args);
    }
  }

  /**
   * Error message - always shows (errors should be visible in all environments)
   */
  static error(message: string, ...args: any[]): void {
    console.error(message, ...args);
  }

  /**
   * Info message - only shows in development mode
   */
  static info(message: string, ...args: any[]): void {
    if (import.meta.env.DEV) {
      console.info(message, ...args);
    }
  }

  /**
   * Debug message - only shows in development mode
   */
  static debug(message: string, ...args: any[]): void {
    if (import.meta.env.DEV) {
      console.debug(message, ...args);
    }
  }

  /**
   * Table display - only shows in development mode
   */
  static table(data: any): void {
    if (import.meta.env.DEV) {
      console.table(data);
    }
  }

  /**
   * Group logging - only shows in development mode
   */
  static group(label: string): void {
    if (import.meta.env.DEV) {
      console.group(label);
    }
  }

  /**
   * Group collapsed logging - only shows in development mode
   */
  static groupCollapsed(label: string): void {
    if (import.meta.env.DEV) {
      console.groupCollapsed(label);
    }
  }

  /**
   * End group logging - only shows in development mode
   */
  static groupEnd(): void {
    if (import.meta.env.DEV) {
      console.groupEnd();
    }
  }

  /**
   * Time measurement start - only works in development mode
   */
  static time(label: string): void {
    if (import.meta.env.DEV) {
      console.time(label);
    }
  }

  /**
   * Time measurement end - only works in development mode
   */
  static timeEnd(label: string): void {
    if (import.meta.env.DEV) {
      console.timeEnd(label);
    }
  }

  /**
   * Count occurrences - only works in development mode
   */
  static count(label?: string): void {
    if (import.meta.env.DEV) {
      console.count(label);
    }
  }

  /**
   * Reset count - only works in development mode
   */
  static countReset(label?: string): void {
    if (import.meta.env.DEV) {
      console.countReset(label);
    }
  }

  /**
   * Clear console - only works in development mode
   */
  static clear(): void {
    if (import.meta.env.DEV) {
      console.clear();
    }
  }
}

export default Logger; 